// A half-filled form survives a reload.
//
// Losing what you typed to a stray refresh is the oldest indignity of the web, and it costs a form
// its answer far more often than a bad label does. The answers are kept as the person types and put
// back when the page returns.
//
// sessionStorage and NOT localStorage, deliberately: a draft survives a reload and a back button,
// and dies with the tab. On a shared machine the next person opening the same form finds it empty,
// which is the behaviour we would want for ourselves.
//
// Passwords are never kept. Neither is anything the destination asked for and nobody filled — the
// decoy included, since restoring a honeypot with a value in it would get the message dropped.

const PREFIX = 'tinyform-draft:';

function key(form) {
	return PREFIX + window.location.pathname;
}

function drafted(form) {
	return Array.from(form.elements).filter((field) => field.name
		&& !field.name.startsWith('_')
		&& !field.dataset.noDraft
		&& field.type !== 'password'
		&& field.type !== 'file'
		&& field.type !== 'submit'
		&& field.type !== 'hidden');
}

function save(form) {
	const state = {};
	drafted(form).forEach((field) => {
		if (field.type === 'checkbox' || field.type === 'radio') {
			if (field.checked) state[field.name] = field.value;
		} else if (field.value) {
			state[field.name] = field.value;
		}
	});
	try {
		if (Object.keys(state).length) {
			sessionStorage.setItem(key(form), JSON.stringify(state));
		} else {
			sessionStorage.removeItem(key(form));
		}
	} catch (ignored) {
		// Private browsing can refuse storage. Losing a draft is a nuisance, not a failure.
	}
}

function restore(form) {
	let state;
	try {
		state = JSON.parse(sessionStorage.getItem(key(form)) || 'null');
	} catch (ignored) {
		return;
	}
	if (!state) return;

	drafted(form).forEach((field) => {
		const saved = state[field.name];
		if (saved === undefined) return;
		if (field.type === 'checkbox' || field.type === 'radio') {
			field.checked = field.value === saved;
		} else {
			field.value = saved;
		}
	});
}

document.querySelectorAll('form.tinyform[data-submission]').forEach((form) => {
	restore(form);
	form.addEventListener('input', () => save(form));
	form.addEventListener('change', () => save(form));
	// Once it has gone somewhere, the draft has done its job and keeping it would put someone's
	// answers in front of the next person to open the tab.
	form.addEventListener('submit', () => {
		try {
			sessionStorage.removeItem(key(form));
		} catch (ignored) {
			// see save()
		}
	});
});
